import { IconButton, Tooltip } from '@mui/material';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';

/**
 * Small info icon with a hover tooltip, shown next to a form field.
 * Renders nothing when no `info` text is provided, so it is safe to use
 * unconditionally inside any field type.
 */
export const FieldInfo = ({ info }) => {
  if (!info) return null;
  return (
    <Tooltip title={info} arrow>
      <IconButton size="small" tabIndex={-1} sx={{ mr: -0.5 }}>
        <InfoOutlinedIcon fontSize="small" />
      </IconButton>
    </Tooltip>
  );
};

export default FieldInfo;
